import React, { createContext, useState, useContext, useEffect } from "react";
import { CustomerContext } from "../customer/CustomerContext";
import { ActionContext } from "../action/ActionContext";

export const ServiceContext = createContext();

export const ServiceProvider = ({ children }) => {
  const { customers } = useContext(CustomerContext);
  const { actions } = useContext(ActionContext);

  const [services, setServices] = useState([
    {
    id: 1,
    customerId: 1,
    brand: "HP",
    device: "Laptop",
    deviceModel: "Pavilion 15",
    issue: "Pil değişimi gerekiyor",
    warranty: "var",
    availableDate: "2025-09-03",
    availableStart: "09:00",
    availableEnd: "17:00",
    urgency: "Yüksek",
    
    resource: "Teknik Personel 1",
    phone3: "5551112233",
    numberOfComplaint: "0",
    actionId: 1
  },
  {
    id: 2,
    customerId: 2,
    brand: "Samsung",
    device: "Telefon",
    deviceModel: "S21",
    issue: "Ekran değişimi",
    warranty: "yok",
    availableDate: "2025-09-04",
    availableStart: "10:00",
    availableEnd: "16:00",
    urgency: "Düşük",
    
    resource: "Teknik Personel 2",
    phone3: "5551112234",
    numberOfComplaint: "0",
    actionId: 2
  },
  {
    id: 3,
    customerId: 3,
    brand: "Apple",
    device: "Tablet",
    deviceModel: "iPad Air",
    issue: "Batarya hızlı tükeniyor",
    warranty: "var",
    availableDate: "2025-09-05",
    availableStart: "08:30",
    availableEnd: "12:00",
    urgency: "Orta",
    
    resource: "Teknik Personel 3",
    phone3: "5551112235",
    numberOfComplaint: "2",
    actionId: 3
  },
  {
    id: 4,
    customerId: 4,
    brand: "Lenovo",
    device: "Laptop",
    deviceModel: "ThinkPad X1",
    issue: "Klavye çalışmıyor",
    warranty: "yok",
    availableDate: "2025-09-06",
    availableStart: "11:00",
    availableEnd: "15:00",
    urgency: "Yüksek",
    
    resource: "Teknik Personel 4",
    phone3: "5551112236",
    numberOfComplaint: "5",
    actionId: 4
  },
  {
    id: 5,
    customerId: 5,
    brand: "Asus",
    device: "Laptop",
    deviceModel: "ZenBook 14",
    issue: "SSD arızalı",
    warranty: "var",
    availableDate: "2025-09-07",
    availableStart: "09:00",
    availableEnd: "18:00",
    urgency: "Düşük",
    
    resource: "Teknik Personel 5",
    phone3: "5551112237",
    numberOfComplaint: "3",
    actionId: 5
  },
  {
    id: 6,
    customerId: 6,
    brand: "Dell",
    device: "Laptop",
    deviceModel: "Inspiron 15",
    issue: "Ekran açılmıyor",
    warranty: "yok",
    availableDate: "2025-09-08",
    availableStart: "13:00",
    availableEnd: "17:30",
    urgency: "Yüksek",
    
    resource: "Teknik Personel 6",
    phone3: "5551112238",
    numberOfComplaint: "6",
    actionId: 6
  },
  {
    id: 7,
    customerId: 7,
    brand: "Sony",
    device: "PlayStation",
    deviceModel: "PS5",
    issue: "Aşırı ısınma",
    warranty: "var",
    availableDate: "2025-09-09",
    availableStart: "09:30",
    availableEnd: "14:00",
    urgency: "Orta",
    
    resource: "Teknik Personel 7",
    phone3: "5551112239",
    numberOfComplaint: "2",
    actionId: 7
  },
  {
    id: 8,
    customerId: 8,
    brand: "Canon",
    device: "Yazıcı",
    deviceModel: "Pixma G3411",
    issue: "Mürekkep akıyor",
    warranty: "var",
    availableDate: "2025-09-10",
    availableStart: "08:00",
    availableEnd: "12:00",
    urgency: "Düşük",
    
    resource: "Teknik Personel 8",
    phone3: "5551112240",
    numberOfComplaint: "1",
    actionId: 8
  },
  {
    id: 9,
    customerId: 9,
    brand: "LG",
    device: "TV",
    deviceModel: "OLED55",
    issue: "Ekran kararıyor",
    warranty: "yok",
    availableDate: "2025-09-11",
    availableStart: "10:00",
    availableEnd: "16:00",
    urgency: "Yüksek",
    
    resource: "Teknik Personel 9",
    phone3: "5551112241",
    numberOfComplaint: "4",
    actionId: 9
  },
  {
    id: 10,
    customerId: 10,
    brand: "Bosch",
    device: "Bulaşık Makinesi",
    deviceModel: "Serie 6",
    issue: "Su boşaltmıyor",
    warranty: "var",
    availableDate: "2025-09-12",
    availableStart: "09:00",
    availableEnd: "18:00",
    urgency: "Yüksek",
    
    resource: "Teknik Personel 10",
    phone3: "5551112242",
    numberOfComplaint: "7",
    actionId: 10
  },
  {
    id: 11,
    customerId: 11,
    brand: "Arçelik",
    device: "Çamaşır Makinesi",
    deviceModel: "9100",
    issue: "Sıkma yapmıyor",
    warranty: "yok",
    availableDate: "2025-09-13",
    availableStart: "12:00",
    availableEnd: "17:00",
    urgency: "Orta",
    
    resource: "Teknik Personel 11",
    phone3: "5551112243",
    numberOfComplaint: "2",
    actionId: 11
  },
  {
    id: 12,
    customerId: 12,
    brand: "Vestel",
    device: "Buzdolabı",
    deviceModel: "NF620",
    issue: "Soğutmuyor",
    warranty: "var",
    availableDate: "2025-09-14",
    availableStart: "10:30",
    availableEnd: "15:30",
    urgency: "Yüksek",
    
    resource: "Teknik Personel 12",
    phone3: "5551112244",
    numberOfComplaint: "5",
    actionId: 12
  },
  {
    id: 13,
    customerId: 13,
    brand: "Siemens",
    device: "Kahve Makinesi",
    deviceModel: "EQ.6",
    issue: "Kahve akmıyor",
    warranty: "yok",
    availableDate: "2025-09-15",
    availableStart: "09:00",
    availableEnd: "12:30",
    urgency: "Orta",
    
    resource: "Teknik Personel 13",
    phone3: "5551112245",
    numberOfComplaint: "3",
    actionId: 13
  },
  {
    id: 14,
    customerId: 14,
    brand: "Philips",
    device: "Süpürge",
    deviceModel: "PowerPro",
    issue: "Motor yanık kokusu",
    warranty: "yok",
    availableDate: "2025-09-16",
    availableStart: "11:00",
    availableEnd: "14:00",
    urgency: "Yüksek",
    
    resource: "Teknik Personel 14",
    phone3: "5551112246",
    numberOfComplaint: "1",
    actionId: 14
  },
  {
    id: 15,
    customerId: 15,
    brand: "Xiaomi",
    device: "Telefon",
    deviceModel: "Mi 11",
    issue: "Şarj olmuyor",
    warranty: "var",
    availableDate: "2025-09-17",
    availableStart: "09:00",
    availableEnd: "17:00",
    urgency: "Yüksek",
    
    resource: "Teknik Personel 15",
    phone3: "5551112247",
    numberOfComplaint: "2",
    actionId: 15
  },
  {
    id: 16,
    customerId: 16,
    brand: "Casper",
    device: "Laptop",
    deviceModel: "Excalibur G900",
    issue: "Fan arızalı",
    warranty: "yok",
    availableDate: "2025-09-18",
    availableStart: "13:00",
    availableEnd: "18:00",
    urgency: "Düşük",
    
    resource: "Teknik Personel 16",
    phone3: "5551112248",
    numberOfComplaint: "3",
    actionId: 16
  },
  {
    id: 17,
    customerId: 17,
    brand: "Monster",
    device: "Laptop",
    deviceModel: "Abra A5",
    issue: "Ekran kartı arızası",
    warranty: "var",
    availableDate: "2025-09-19",
    availableStart: "09:30",
    availableEnd: "16:30",
    urgency: "Yüksek",
    
    resource: "Teknik Personel 17",
    phone3: "5551112249",
    numberOfComplaint: "4",
    actionId: 17
  },
  ]);

  const mergeCustomerName = (serviceList) =>
    serviceList.map((service) => {
      const customer = customers.find((c) => c.id === service.customerId);
      const action = actions.find((a) => a.id === service.actionId);
      return {
        ...service,
        customerName: customer ? customer.fullName : "Bilinmiyor",
        serviceFullName: `${service.brand} ${service.deviceModel || ""} `.trim(),
        actionName: action ? action.name : "Beklemede",
      };
    });

  const [mergedServices, setMergedServices] = useState(mergeCustomerName(services));

  useEffect(() => {
    setMergedServices(mergeCustomerName(services));
  }, [services, customers, actions]);

  const addService = (formData) => {
    const newService = {
      id: services.length + 1,
      ...formData,
      serviceFullName: `${formData.brand} ${formData.deviceModel || ""} ${formData.device}`.trim(),
      urgency: formData.urgency || false,
      
      resource: "Atanmadı",
      actionId: formData.actionId || 1, 
    };
    setServices((prev) => [...prev, newService]);
  };

  const updateService = (id, updatedData) => {
    setServices((prev) =>
      prev.map((service) =>
        service.id === id
          ? {
              ...service,
              ...updatedData,
              serviceFullName: `${updatedData.brand || service.brand} ${updatedData.deviceModel || service.deviceModel || ""} ${updatedData.device || service.device}`.trim(),
            }
          : service
      )
    );
  };

  const deleteService = (id) => {
    setServices((prev) => prev.filter((service) => service.id !== id));
  };

  return (
    <ServiceContext.Provider
      value={{
        services: mergedServices,
        addService,
        updateService,
        deleteService,
      }}
    >
      {children}
    </ServiceContext.Provider>
  );
};
